﻿export class WarehouseDocument {
    warehouseDocumentDate = null;
}
